import { LoaConsultProvider } from '../../../Contexts/LoaConsultContext'
import { Outlet } from 'react-router-dom'

function LoaConsult() {
	return (
    <LoaConsultProvider>
      <Outlet />
    </LoaConsultProvider>
	)
}

export default LoaConsult